// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum FilterGroupType {
    AllFilter = 0,
    Allgemein = 1,
    Benutzerspezifisch = 2,
}

export const FilterGroupTypeLabels: {[k: string]: string} = {
    [FilterGroupType.AllFilter]: t('ix2048:enum.FilterGroupType.AllFilter'),
    [FilterGroupType.Allgemein]: t('ix2048:enum.FilterGroupType.Allgemein'),
    [FilterGroupType.Benutzerspezifisch]: t('ix2048:enum.FilterGroupType.Benutzerspezifisch'),
}

export const filterGroupTypeToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in FilterGroupType) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(FilterGroupTypeLabels[FilterGroupType[x as keyof typeof FilterGroupType]]),
            value: FilterGroupType[x as keyof typeof FilterGroupType],
        })
    }

    return opts
}
